import { render } from "./mallTabBar.vue?vue&type=template&id=adfea830&scoped=true"
import script from "./mallTabBar.vue?vue&type=script&lang=js"
export * from "./mallTabBar.vue?vue&type=script&lang=js"

import "./mallTabBar.vue?vue&type=style&index=0&id=adfea830&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adfea830"]])

export default __exports__